"use client";

import { Alert, Box, Button, Container, Typography } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";

import theme from "@/lib/theme";

interface FallbackProps {
  error: unknown;
  componentStack: string;
  eventId: string;
  resetError: () => void;
}

export const Fallback = ({ resetError }: FallbackProps) => (
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <Container maxWidth="sm">
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="100vh"
        gap={3}>
        <Alert severity="error" sx={{ width: "100%" }}>
          <Typography variant="h6" gutterBottom>
            Something went wrong
          </Typography>
          <Typography variant="body2">
            An unexpected error occurred while loading the application. Please try refreshing the page or
            contact support if the problem persists.
          </Typography>
        </Alert>

        <Box display="flex" gap={2}>
          <Button variant="contained" color="primary" onClick={resetError}>
            Try Again
          </Button>
          <Button variant="outlined" color="primary" onClick={() => window.location.reload()}>
            Refresh Page
          </Button>
        </Box>
      </Box>
    </Container>
  </ThemeProvider>
);
